import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { STR_BUY_NOW, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED } from "../Strings";
import { MdCall, MdMessage, MdWarning, MdWhatsapp } from "react-icons/md";

export default function View({ data, canView = true }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		if(canView) {
			appContext.navTo({
				item: "side-view",
				subItem: "contact-options",
				extraItem: data.id,
			});
		}
	}

	return (
		<div
			className="card"
			onClick={view}
		>
			<div className="card-body">
				<h6
					style={{
						fontSize: "22px",
					}}
					className="font-semi-bold text-secondary mb-4"
				>
					{data.name}
				</h6>

				<div className="mt-4 d-flex justify-content-end">

					<div className="d-flex m-1">
						<MdMessage className="align-self-center" size={24}/>
						<h6
							style={{
								fontSize: "12px",
							}}
							className="font-semi-bold align-self-center mNoMargin"
						>
							{data.phoneNumber}
						</h6>

					</div>

					<div className="d-flex m-1">
						<MdWhatsapp className="align-self-center" size={24}/>
						<h6
							style={{
								fontSize: "12px",
							}}
							className="font-semi-bold align-self-center mNoMargin"
						>
							{data.whatsAppNumber || "N/A"}
						</h6>
					</div>

				</div>

				{
					(data.reason) ?
					<h6
						className="text-danger mt-4"
						style={{
							fontSize: "14px"
						}}
					>
						<MdWarning size={24}/> {data.reason}
					</h6>
					:""
				}
			</div>
		</div>
	);
}
